import { ServiceCategory } from 'chaika-frontend-types/frontend-cms';

import { OptionType } from '@components/Select';
import { translate } from '@chaika/i18n/helper';
import { getServiceCategoryTranslation } from '@utils/enumTranslation';

export const durationOptions = (): OptionType<number>[] => [
    {
        value: 5,
        label: `5 ${translate('minuteShort')}`,
    },
    {
        value: 10,
        label: `10 ${translate('minuteShort')}`,
    },
    {
        value: 15,
        label: `15 ${translate('minuteShort')}`,
    },
    {
        value: 20,
        label: `20 ${translate('minuteShort')}`,
    },
    {
        value: 25,
        label: `25 ${translate('minuteShort')}`,
    },
    {
        value: 30,
        label: `30 ${translate('minuteShort')}`,
    },
    {
        value: 35,
        label: `35 ${translate('minuteShort')}`,
    },
    {
        value: 40,
        label: `40 ${translate('minuteShort')}`,
    },
    {
        value: 45,
        label: `45 ${translate('minuteShort')}`,
    },
    {
        value: 50,
        label: `50 ${translate('minuteShort')}`,
    },
    {
        value: 55,
        label: `55 ${translate('minuteShort')}`,
    },
    {
        value: 60,
        label: `60 ${translate('minuteShort')}`,
    },
    {
        value: 65,
        label: `65 ${translate('minuteShort')}`,
    },
    {
        value: 70,
        label: `70 ${translate('minuteShort')}`,
    },
    {
        value: 75,
        label: `75 ${translate('minuteShort')}`,
    },
    {
        value: 80,
        label: `80 ${translate('minuteShort')}`,
    },
    {
        value: 85,
        label: `85 ${translate('minuteShort')}`,
    },
    {
        value: 90,
        label: `90 ${translate('minuteShort')}`,
    },
    {
        value: 120,
        label: `120 ${translate('minuteShort')}`,
    },
];

export const categoryOptions = (): OptionType<ServiceCategory>[] => [
    {
        value: ServiceCategory.Consultation,
        label: getServiceCategoryTranslation(ServiceCategory.Consultation),
    },
    {
        value: ServiceCategory.Dentistry,
        label: getServiceCategoryTranslation(ServiceCategory.Dentistry),
    },
    {
        value: ServiceCategory.Laboratory,
        label: getServiceCategoryTranslation(ServiceCategory.Laboratory),
    },
    {
        value: ServiceCategory.Hospital,
        label: getServiceCategoryTranslation(ServiceCategory.Hospital),
    },
    {
        value: ServiceCategory.Clinic,
        label: getServiceCategoryTranslation(ServiceCategory.Clinic),
    },
    {
        value: ServiceCategory.Radiodiagnosis,
        label: getServiceCategoryTranslation(ServiceCategory.Radiodiagnosis),
    },
    {
        value: ServiceCategory.UltrasoundDiagnostics,
        label: getServiceCategoryTranslation(ServiceCategory.UltrasoundDiagnostics),
    },
    {
        value: ServiceCategory.Archive,
        label: getServiceCategoryTranslation(ServiceCategory.Archive),
    },
    {
        value: ServiceCategory.Technical,
        label: getServiceCategoryTranslation(ServiceCategory.Technical),
    },
    {
        value: ServiceCategory.MaterialsAndPreparations,
        label: getServiceCategoryTranslation(ServiceCategory.MaterialsAndPreparations),
    },
    {
        value: ServiceCategory.CheckUp,
        label: getServiceCategoryTranslation(ServiceCategory.CheckUp),
    },
    {
        value: ServiceCategory.OneCProduct,
        label: getServiceCategoryTranslation(ServiceCategory.OneCProduct),
    },
    {
        value: ServiceCategory.Vaccination,
        label: getServiceCategoryTranslation(ServiceCategory.Vaccination),
    },
];

export const dentalMultiSelectServiceTag = 'f5c793fa-042a-4c6d-b0c7-d182888849a7';
export const referralDoctorRequiredServiceTag = '02032e34-3670-411b-9987-e0592d599d28';
